module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptust331-2560x1440.337d277e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptust331-2560x1440.jpg
// module id = 1015
// module chunks = 37